export default __webpack_public_path__ + "static/media/1.5eb6ea13.jpg";